import React, { useRef } from 'react'
import { Button, OverlayTrigger, Popover } from 'react-bootstrap'
import { useText } from '../context/TextContext';
import { AdvancedButton } from './AdvancedButton';

interface Props {
    header: string
    children: React.ReactElement
    onConfirm: () => Promise<void>
}

export default function DropdownConfirm(props: Props) {
    const containerRef = useRef<HTMLSpanElement>(null);
    const [processing, setProcessing] = React.useState(false);
    const text = useText();

    const closeOverlay = () => containerRef.current?.click();

    const handleConfirm = async () => {
        setProcessing(true);
        await props.onConfirm();
        setProcessing(false);
        closeOverlay();
    }

    return (
        <OverlayTrigger rootClose
            overlay={
                <Popover>
                    <Popover.Header as='h3'>{props.header}</Popover.Header>
                    <Popover.Body>
                        <p>{text.thisActionCannotBeUndone}</p>
                        <div className='d-flex justify-content-between gap-1'>
                            <AdvancedButton processing={processing} size='sm' className='btn btn-danger' onClick={handleConfirm} >{text.confirm}</AdvancedButton>
                            <Button size="sm" className='btn btn-secondary' onClick={closeOverlay}>{text.cancel}</Button>
                        </div>
                    </Popover.Body>
                </Popover>
            }
            trigger="click"
            placement="bottom-end"
        >

            {({ ref: triggerRef, ...triggerProps }) => (
                <span ref={containerRef}>
                    {React.cloneElement(props.children, { ref: triggerRef, ...triggerProps })}
                </span>
            )}
        </OverlayTrigger>
    )
}
